'use client';

import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import MarketingReveal from '@/components/website/Marketing/MarketingReveal';

function paragraphsFromBody(body) {
  if (!body) return [];
  if (Array.isArray(body)) return body.filter(Boolean);
  return String(body)
    .split(/\n\n+/)
    .map(part => part.trim())
    .filter(Boolean);
}

export default function TradeIntro({ id, title = '', body = '' }) {
  const paragraphs = paragraphsFromBody(body);

  return (
    <MarketingReveal from="up" animate={false}>
      <Box component="section" id={id} sx={{ py: { xs: 6, md: 10 } }}>
        <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
          {title ? (
            <MarketingReveal observe={false} delay={0} from="up">
              <Typography variant="h3" sx={{ fontWeight: 500, mb: 2 }}>
                {title}
              </Typography>
            </MarketingReveal>
          ) : null}
          {paragraphs.map((paragraph, index) => (
            <MarketingReveal
              key={`${index}-${paragraph.slice(0, 24)}`}
              observe={false}
              delay={0.12 * (index + 1)}
              from="up"
            >
              <Typography
                variant="body1"
                sx={{
                  maxWidth: 840,
                  mx: 'auto',
                  lineHeight: 1.7,
                  mb: index < paragraphs.length - 1 ? 2 : 0,
                }}
              >
                {paragraph}
              </Typography>
            </MarketingReveal>
          ))}
        </Container>
      </Box>
    </MarketingReveal>
  );
}

TradeIntro.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};
